import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import img from '../../../img/logo.png';

export default class Logotip extends Component {
  render() {
    return (
      <Link className="navbar-brand" to="/">
        <img
          className=" mr-2"
          src={img}
          width="30"
          height="30"
          alt="Logo"
        ></img>
        CVAD ONLINE
      </Link>
    );
  }
}
